module.exports = __webpack_public_path__ + "static/media/logo.bbe230e9.png";